import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c1577474&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=c1577474&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_75d14e9340cbf130d0af91897aeb0542/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1577474",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MonorepoOverview: require('/build/apps/legacy/components/Monorepo/MonorepoOverview.vue').default,IssueOverviewCards: require('/build/apps/legacy/components/RepoOverview/IssueOverviewCards.vue').default,MetadataView: require('/build/apps/legacy/components/Repository/MetadataView.vue').default,MetadataViewMobile: require('/build/apps/legacy/components/Repository/MetadataViewMobile.vue').default,AddSubRepositoryModal: require('/build/apps/legacy/components/Monorepo/AddSubRepositoryModal.vue').default})
